import React, {useEffect, useState} from "react";
import localStorageService from "../services/localStorageService";
import portalService from "../services/portalService";

const Locks = () => {
    const [locks, setLocks] = useState([]);

    const [lockNum, setLockNum] = useState("");
    const [lockPin, setLockPin] = useState("");

    useEffect(() => {
        if (localStorageService && localStorageService.locks && localStorageService.locks.get()) {
            setLocks(localStorageService.locks.get());
        }
    }, []);

    const clearFields = () => {
        setLockNum("");
        setLockPin("");
    }

    const modalClosed = (e) => {
        clearFields();
    }

    const addNew = (e) => {
        const newLock = {
            serialNumber: lockNum,
            pin: lockPin
        };
        portalService.addLock(newLock).then(r => {
            const existing = [...locks];
            existing.push({id: r.data.id, ...newLock});
            localStorageService.locks.set(existing);
            setLocks(existing);
            clearFields();
        }).catch(e => {

        });
        
    }

    const modal = () => {
        return (
            <div className="modal fade" id="new-lock-modal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 v="modal-title fs-5" id="staticBackdropLabel">Новый замок</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <form className="form-floating">
                                <div className="form-floating mb-3">
                                    <input type="text" className="form-control" id="new-box-code" required placeholder="" value={lockNum} onChange={(e) => setLockNum(e.target.value)}/>
                                    <label htmlFor="new-box-code">Номер замка</label>
                                </div>
                                <div className="form-floating mb-3">
                                    <input type="text" className="form-control" id="new-box-num" required placeholder="" value={lockPin} onChange={(e) => setLockPin(e.target.value)}/>
                                    <label htmlFor="new-box-num">Пин код</label>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={modalClosed}>Закрыть</button>
                                    <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={addNew}>Сохранить</button>
                                </div>
                            </form>
                        </div>       
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="">
            <h3 className="mb-4">Замки: {locks.length}</h3>
            <table className="table table-striped table-hover">
                <thead className="table">
                    <tr>
                        <th scope="col">Серийный номер</th>
                        <th scope="col">Пин</th>
                    </tr>
                    <tr>
                        <th scope="col"><input type='text' className="form-control"/></th>
                        <th scope="col"><input type='text' className="form-control"/></th>
                    </tr>
                </thead>
                <tbody>
                    {locks.map((row) => (
                        <tr key={row.id}>
                            <td>{row.serialNumber}</td>
                            <td>{row.pin}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div>
                <button className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#new-lock-modal">Добавить+</button>
            </div>
            {modal()}
        </div>
    );
}

export default Locks;